import { render } from "./HeroiconsSolidDotsCircleHorizontal.vue?vue&type=template&id=46c4b074"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDotsCircleHorizontal.vue"]])

export default __exports__